import { PasswordValidation } from '../types/loginModal';

export const validatePassword = (pwd: string): PasswordValidation => ({
  hasMinLength: pwd.length >= 8,
  hasUpperCase: /[A-Z]/.test(pwd),
  hasLowerCase: /[a-z]/.test(pwd),
  hasNumber: /[0-9]/.test(pwd),
  hasSymbol: /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(pwd),
});

export const isPasswordValid = (v: PasswordValidation): boolean =>
  Object.values(v).every(Boolean);
